module.exports = __webpack_public_path__ + "img/ZweierleiSinnes.04d36372.jpg";